export default function InvalidLink() {
  return (
    <div>
      <p>This link is invalid or has expired. Please contact your provider.</p>
    </div>
  )
}